import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../../components";

// include action file for add merchant
import "../../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../../components/notifications";
import isEmpty from "lodash.isempty";
import CountryStateCity from "../../../../components/countryStateCity/CountryStateCity";
import { countryCityActions } from "../../../../redux/actions/countryCityActions";
import { getDealCities } from "../../../../redux/actions/dealActions";
import { get_afuser_details } from "../../../../redux/actions/subAdminActions";
import {
  getCust_SalesManagerList,
  add_affiliate,
  getAffiliateDetails,
  update_affiliate
} from "../../../../redux/actions/affiliateActions";
import { appConfig } from "../../../../config";
import {
  renderAlert,
  clearAlert
} from "../../../../redux/actions/alertsActions";
import loader from "../../../../style/loader/loader.scss";
import {aclUtil} from "../../../util"
import NumberFormat from "react-number-format";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

let disabled = false,
  isLoading = "false";
class AddAffiliate extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'ADD_AFFILIATE',
      path: ["Home", "Manage Affiliates", "Add New"],
      links: ["home", "affiliateList","addAffiliate"],
      alertMessage: "",
      msgType: "",
      siteUrl: appConfig.site.siteurl,
      account_name: "",
      permalink: "",
      legal_name: "",
      TIN_SSN: "",
      websiteUrl: "",
      domainType: "http://",
      DealcityID: "",
      bannerHeadline: "",
      notes: "",
      user_id: "",
      userName: "",
      firstName: "",
      lastName: "",
      gender: "Male",
      phone: "",
      email: "",
      address1: "",
      address2: "",
      country: "",
      state: "",
      city: "",
      cityID: "",
      zipcode: "",
      stateAbbr: "",
      perSubscriber: "",
      flatPerSale: "",
      firstSale: "",
      subsequentSales: "",
      processingFees: "",
      paidOn: "Sales",
      status: "Pending",
      append_aff_id: "0",
      custSalesListData: [],
      dealCitiesData: [],
      userNameError: "",
      emailError: "",
      firstNameError: "",
      lastNameError: "",
      phoneError: "",
      address1Error: "",
      cityError: "",
      stateError: "",
      countryError: "",
      zipError: "",
      websiteUrlError: "",
      affiliateID: "",
      disabled: "",
      show: false
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeOnUser = this.handleChangeOnUser.bind(this);
    this.Clear = this.Clear.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleChangeOnUser(e) {
    this.setState({ user_id: e.target.value });
    this.setState({ disabled: false });
    if (e.target.value !== "") {
      this.props.get_afuser_details(e.target.value);
      this.setState({ append_aff_id: 1 });
      isLoading = "true";
    } else {
      this.setState({ append_aff_id: 0 });
    }
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  // Handle input onchange
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ disabled: false });
  }

  getValidationState() {
    if (this.state.websiteUrl) {
      const length = this.state.websiteUrl.length;
      if (length !== 0) {
        if (
          !/^((https?|ftp|smtp):\/\/)+(www.)+[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/gi.test(
            this.state.websiteUrl
          )
        ) {
          return "error";
        }
      }
    }

    return null;
  }

  getValidationPhoneState() {
    if (this.state.phone) {
      const length = this.state.phone.length;
      if (length !== 0) {
        let mobilepattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
        if (!mobilepattern.test(this.state.phone)) {
          return "error";
        }
      }
    }

    return null;
  }

  getValidationEmailState() {
    if (this.state.email) {
      const length = this.state.email.length;
      if (length !== 0) {
        let emailpattern = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if (!emailpattern.test(this.state.email)) {
          return "error";
        }
      }
    }

    return null;
  }

  validate = () => {
    let isError = false;
    const errors = {};
    let pattern = new RegExp('^(ftp|http|https)://[^ "]+$');
    if (!this.state.user_id) {
      if (!this.state.userName) {
        isError = true;
        this.setState({ userNameError: "red" });
      } else {
        this.setState({ userNameError: "" });
      }

      if (!this.state.email) {
        isError = true;
        this.setState({ emailError: "red" });
      } else if (this.state.email) {
        if (this.getValidationEmailState()) {
          isError = true;
        }
      } else {
        this.setState({ emailError: "" });
      }
      if (!this.state.firstName) {
        isError = true;
        this.setState({ firstNameError: "red" });
      } else {
        this.setState({ firstNameError: "" });
      }
      if (!this.state.lastName) {
        isError = true;
        this.setState({ lastNameError: "red" });
      } else {
        this.setState({ lastNameError: "" });
      }

      if (this.state.phone) {
        if (this.getValidationPhoneState()) {
          isError = true;
        }
      }

      if (!this.state.address1) {
        isError = true;
        this.setState({ address1Error: "red" });
      } else {
        this.setState({ address1Error: "" });
      }
      if (!this.state.city) {
        isError = true;
        this.setState({ cityError: "true" });
      } else {
        this.setState({ cityError: "" });
      }
      if (!this.state.state) {
        isError = true;
        this.setState({ stateError: "true" });
      } else {
        this.setState({ stateError: "" });
      }
      if (!this.state.country) {
        isError = true;
        this.setState({ countryError: "true" });
      } else {
        this.setState({ countryError: "" });
      }
    }

    if (!this.state.account_name) {
      isError = true;
      this.setState({ account_nameError: "red" });
    } else {
      this.setState({ account_nameError: "" });
    }
    if (!this.state.permalink) {
      isError = true;
      this.setState({ permalinkError: "red" });
    } else {
      this.setState({ permalinkError: "" });
    }

    if (this.state.websiteUrl) {
      if (
        !/^((https?|ftp|smtp):\/\/)+(www.)+[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/gi.test(
          this.state.websiteUrl
        )
      ) {
        isError = true;
        this.setState({ websiteUrlError: "red" });
      }
    }
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      this.setState({ disabled: true });
      if (this.state.affiliateID !== "") {
        const postData = {
          affiliateID: this.state.affiliateID,
          account_name: this.state.account_name,
          legal_name: this.state.legal_name,
          websiteUrl: this.state.websiteUrl,
          permalink: this.state.permalink,
          TIN_SSN: this.state.TIN_SSN,
          DealcityID: this.state.DealcityID,
          bannerHeadline: this.state.bannerHeadline,
          notes: this.state.notes,
          userName: this.state.userName,
          email: this.state.email,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          gender: this.state.gender,
          phone: this.state.phone,
          address1: this.state.address1,
          address2: this.state.address2,
          cityID: this.state.cityID,
          city: this.state.city,
          state: this.state.state,
          stateAbbr: this.state.stateAbbr,
          country: this.state.country,
          zipcode: this.state.zipcode ? this.state.zipcode : "",
          perSubscriber: this.state.perSubscriber,
          flatPerSale: this.state.flatPerSale,
          firstSale: this.state.firstSale,
          subsequentSales: this.state.subsequentSales,
          processingFees: this.state.processingFees,
          paidOn: this.state.paidOn,
          status: this.state.status,
          userID: this.state.user_id,
          append_aff_id: this.state.append_aff_id
        };
        this.props.update_affiliate(postData);
      } else {
        const postData = {
          account_name: this.state.account_name,
          legal_name: this.state.legal_name,
          websiteUrl: this.state.websiteUrl,
          permalink: this.state.permalink,
          TIN_SSN: this.state.TIN_SSN,
          DealcityID: this.state.DealcityID,
          bannerHeadline: this.state.bannerHeadline,
          notes: this.state.notes,
          userName: this.state.userName,
          email: this.state.email,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          gender: this.state.gender,
          phone: this.state.phone,
          address1: this.state.address1,
          address2: this.state.address2,
          cityID: this.state.cityID,
          city: this.state.city,
          state: this.state.state,
          stateAbbr: this.state.stateAbbr,
          country: this.state.country,
          zipcode: this.state.zipcode ? this.state.zipcode : "",
          perSubscriber: this.state.perSubscriber,
          flatPerSale: this.state.flatPerSale,
          firstSale: this.state.firstSale,
          subsequentSales: this.state.subsequentSales,
          processingFees: this.state.processingFees,
          paidOn: this.state.paidOn,
          status: this.state.status,
          userID: this.state.user_id,
          append_aff_id: this.state.append_aff_id
        };
        this.props.add_affiliate(postData);
      }
    }
  }

  onSelectedCountry = (val, key) => {
    this.setState({ country: val });
    this.setState({ countryName: key });
    if (!this.state.country) {
      this.setState({ countryError: "" });
    }

    if(this.state.country != val){
      this.setState({state: '', stateAbbr: '', city: '', cityID: ''});
    }
    this.setState({ disabled: false });
  };

  onSelectedState = (val, key) => {
    this.setState({ state: key });
    this.setState({ stateAbbr: val });
    if (!this.state.state) {
      this.setState({ stateError: "" });
    }
    this.setState({ disabled: false });
  };

  onSelectedCity = (val, key) => {
    this.setState({ city: val });
    this.setState({ cityID: key });
    if (!this.state.city) {
      this.setState({ cityError: "" });
    }
    this.setState({ disabled: false });
  };

  handlePageChange = page => {
    this.props.get_merchant_list();
  };

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    this.props.getCust_SalesManagerList();
    this.props.getDealCities();
    let affiliateIdParams = this.props.match.params.affiliateID
      ? this.props.match.params.affiliateID
      : "";
    const editLink = this.props.match.params.affiliateID && `addAffiliate/${this.props.match.params.affiliateID}`
    if (affiliateIdParams !== "") {
      isLoading = "true";
      this.props.getAffiliateDetails(affiliateIdParams);
      this.state.path = ["Home", "Manage Affliate", "Edit Affiliate"];
      this.state.links = ["home", "affiliateList",editLink];
    }
  }

  Clear() {
    (this.state.account_name = ""),
      (this.state.legal_name = ""),
      (this.state.websiteUrl = ""),
      (this.state.permalink = ""),
      (this.state.TIN_SSN = ""),
      (this.state.DealcityID = ""),
      (this.state.bannerHeadline = ""),
      (this.state.notes = ""),
      (this.state.userName = ""),
      (this.state.email = ""),
      (this.state.firstName = ""),
      (this.state.lastName = ""),
      (this.state.gender = ""),
      (this.state.phone = ""),
      (this.state.address1 = ""),
      (this.state.address2 = ""),
      (this.state.cityID = ""),
      (this.state.city = ""),
      (this.state.state = ""),
      (this.state.stateAbbr = ""),
      (this.state.zipcode = ""),
      (this.state.perSubscriber = ""),
      (this.state.flatPerSale = ""),
      (this.state.firstSale = ""),
      (this.state.subsequentSales = ""),
      (this.state.processingFees = ""),
      (this.state.paidOn = ""),
      (this.state.status = "Pending"),
      (this.state.user_id = ""),
      (this.state.append_aff_id = ""),
      (disabled = false);
  }

  componentWillReceiveProps(nextProps) {
    let tmpAclKey = this.state.menuKey;
    if(this.props.match.params.affiliateID){
      tmpAclKey = 'EDIT_AFFILIATE';
    }
    if(!aclUtil.isPrimaryMenuAccessible(tmpAclKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    
    if (this.props.custSalesList !== nextProps.custSalesList) {
      if (nextProps.custSalesList) {
        this.setState({ custSalesListData: nextProps.custSalesList.data });
      }
    }

    if (this.props.dealCities !== nextProps.dealCities) {
      if (nextProps.dealCities) {
        this.setState({ dealCitiesData: nextProps.dealCities });
      }
    }

    if (this.props.affiliateResponse !== nextProps.affiliateResponse) {
      if (nextProps.affiliateResponse) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.affiliateResponse.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.Clear();
        this.onSelectedCountry();
        window.scrollTo(0, 0);
      }
    }

    if (this.props.updatedAffiliate !== nextProps.updatedAffiliate) {
      if (nextProps.updatedAffiliate) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.updatedAffiliate.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.props.getAffiliateDetails(this.state.affiliateID);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.message !== nextProps.message) {
      if (nextProps.message) {
        this.handleShow();
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        window.scrollTo(0, 0);
      }
    }

    if (this.props.affiliateDetail !== nextProps.affiliateDetail) {
      if (nextProps.affiliateDetail) {
        let affiliate = nextProps.affiliateDetail;
        isLoading = "false";
        this.setState({
          affiliateID: affiliate.affiliateID,
          account_name: affiliate.account_name,
          legal_name: affiliate.legal_name,
          websiteUrl: affiliate.websiteUrl,
          permalink: affiliate.permalink,
          TIN_SSN: affiliate.TIN_SSN,
          DealcityID: affiliate.affiliateCityID,
          deal_city: affiliate.deal_city,
          bannerHeadline: affiliate.bannerHeadline,
          notes: affiliate.notes,
          userName: affiliate.userName,
          email: affiliate.email,
          firstName: affiliate.firstName,
          lastName: affiliate.lastName,
          gender: affiliate.gender,
          phone: affiliate.phone,
          address1: affiliate.address1,
          address2: affiliate.address2,
          city: affiliate.city,
          country: affiliate.country,
          cityID: affiliate.cityID,
          state: affiliate.state,
          stateAbbr: affiliate.stateAbbr,
          zipcode: affiliate.zipcode,

          perSubscriber: affiliate.perSubscriber,
          flatPerSale: affiliate.flatPerSale,
          firstSale: affiliate.firstSale,
          subsequentSales: affiliate.subsequentSales,
          processingFees: affiliate.processingFees,
          paidOn: affiliate.paidOn,
          append_aff_id: affiliate.append_aff_id,
          status: affiliate.status
        });
      }
    }

    if (this.props.userDetails !== nextProps.userDetails) {
      if (nextProps.userDetails) {
        let user = nextProps.userDetails.data;
        if (user) {
          isLoading = false;
        
        this.setState({
          user_id: user.user_id,
          address1: user.address1,
          address2: user.address2,
          city: user.city,
          cityID: user.cityID,
          country: user.country,
          email: user.email,
          firstName: user.firstName,
          gender: user.gender,
          lastName: user.lastName,
          phone: user.phone,
          state: user.state,
          stateAbbr: user.stateAbbr,
          userName: user.userName,
          zipcode: user.zipcode
        });
      }
      else
      {
        isLoading = false;
      }
    }
    else
      {
     {
      isLoading = false;
     }  
      }
    }
  }

  render() {
    let custSalesListData = this.state.custSalesListData
      ? this.state.custSalesListData
      : [];
    let dealCitiesData = this.state.dealCitiesData
      ? this.state.dealCitiesData
      : [];

    this.state.user_id
      ? $("#contractdiv *").prop("disabled", true)
      : $("#contractdiv *").prop("disabled", false);
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <form onSubmit={this.handleSubmit}>
          <div className="row">
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          {/**start Affiliate detail **/}

          <div className="panel">
            <header className="panel-heading">Affiliate Details</header>

            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formAccountName">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Account Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.account_name}
                        placeholder="Account Name"
                        onChange={this.handleChange}
                        name="account_name"
                        style={{ borderColor: this.state.account_nameError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="formLegalName">
                      <ControlLabel>Legal Name</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.legal_name}
                        placeholder="Legal Name"
                        onChange={this.handleChange}
                        name="legal_name"
                      />
                    </FormGroup>
                    <ControlLabel>
                      Website (format: http://www.example.com)
                    </ControlLabel>
                    <FormGroup
                      controlId="formWebsite"
                      validationState={this.getValidationState()}
                    >
                      <FormControl
                        type="text"
                        value={this.state.websiteUrl}
                        placeholder="Website"
                        onChange={this.handleChange}
                        name="websiteUrl"
                        style={{ borderColor: this.state.websiteUrlError }}
                      />
                    </FormGroup>

                    <FormGroup controlId="formPermalinkText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Permalink
                      </ControlLabel>

                      <FormControl
                        type="text"
                        value={this.state.permalink}
                        placeholder="Permalink"
                        onChange={this.handleChange}
                        name="permalink"
                        style={{ borderColor: this.state.permalinkError }}
                      />

                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formTin">
                      <ControlLabel>TIN/SSN</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.TIN_SSN}
                        placeholder="TIN/SSN"
                        onChange={this.handleChange}
                        name="TIN_SSN"
                      />
                    </FormGroup>
                    <FormGroup controlId="formCity">
                      <ControlLabel>City</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="DealcityID"
                        onChange={this.handleChange}
                        value={this.state.DealcityID}
                      >
                        <option value="">Select City</option>
                        {dealCitiesData.map((el, key) => {
                          if(el) {
                            return (
                              <option key={key} value={el.cityID}>
                                {el.title}
                              </option>
                            );
                          } 
                        })}
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formBanner">
                      <ControlLabel>Banner Headline</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.bannerHeadline}
                        placeholder="Offer of the Day"
                        onChange={this.handleChange}
                        name="bannerHeadline"
                      />
                    </FormGroup>
                    <FormGroup controlId="formNotes">
                      <ControlLabel>Notes</ControlLabel>
                      <FormControl
                        value={this.state.notes}
                        componentClass="textarea"
                        placeholder="Notes"
                        onChange={this.handleChange}
                        name="notes"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end Affiliate information **/}

          {/**start Contact / Payment Information **/}
          <div id="contractdiv" className="panel">
            <header className="panel-heading">
              Contact / Payment Information{" "}
            </header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formBasicUserNameText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> User Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        name="userName"
                        value={this.state.userName}
                        placeholder="Enter User Name"
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.userNameError }}
                      />
                    </FormGroup>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Email
                    </ControlLabel>
                    <FormGroup
                      controlId="formEmail"
                      validationState={this.getValidationEmailState()}
                    >
                      <FormControl
                        type="email"
                        value={this.state.email}
                        placeholder="Email"
                        onChange={this.handleChange}
                        name="email"
                        style={{ borderColor: this.state.emailError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicFirstNameText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> First Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.firstName}
                        placeholder="Enter First Name"
                        onChange={this.handleChange}
                        name="firstName"
                        style={{ borderColor: this.state.firstNameError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicLastNameText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Last Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.lastName}
                        placeholder="Enter Last Name"
                        onChange={this.handleChange}
                        name="lastName"
                        style={{ borderColor: this.state.lastNameError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="formControlsSelect">
                      <ControlLabel>Gender</ControlLabel>
                      <FormControl
                        componentClass="select"
                        placeholder="Gender"
                        name="gender"
                        value={this.state.gender}
                        onChange={this.handleChange}
                      >
                        <option value="Male">Male</option>
                        <option value="Female"> Female </option>
                      </FormControl>
                      <p className="inline-validation-error" />
                    </FormGroup>
                    <ControlLabel>Phone (format: xxx-xxx-xxxx) </ControlLabel>
                    <FormGroup
                      controlId="formphoneNumber"
                      validationState={this.getValidationPhoneState()}
                    >
                      <NumberFormat
                        format="###-###-####"
                        mask="_"
                        className="form-control"
                        name="phone"
                        placeholder="Enter Phone Number"
                        value={this.state.phone}
                        onChange={this.handleChange}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={6} xs={12}>
                    <FormGroup controlId="formAddress">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Address (Where
                        we sent their cheque)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.address1}
                        placeholder="Address"
                        onChange={this.handleChange}
                        name="address1"
                        style={{ borderColor: this.state.address1Error }}
                      />
                    </FormGroup>
                    <FormGroup controlId="formAddress2">
                      <ControlLabel>Address (Line 2)</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.address2}
                        placeholder="Address"
                        onChange={this.handleChange}
                        name="address2"
                      />
                    </FormGroup>

                    <div className="form-group">
                      <CountryStateCity
                        onSelectedCountry={this.onSelectedCountry}
                        onSelectedState={this.onSelectedState}
                        onSelectedCity={this.onSelectedCity}
                        country={this.state.country}
                        state={this.state.state}
                        stateAbbr={this.state.stateAbbr}
                        city={this.state.city}
                        cityID={this.state.cityID}
                        countryerror={this.state.countryError}
                        stateerror={this.state.stateError}
                        cityerror={this.state.cityError}
                      />
                    </div>
                    <FormGroup controlId="formZipCode">
                      <ControlLabel>Zip Code</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.zipcode}
                        placeholder="Zip Code"
                        onChange={this.handleChange}
                        name="zipcode"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end Contact / Payment Information **/}

          {/**start Commission Rates **/}
          <div className="panel">
            <header className="panel-heading">Commission Rates</header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={12} xs={12}>
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th />
                          <th>Per Subscriber</th>
                          <th>Flat Per Sale</th>
                          <th>First Sale</th>
                          <th>Subsequent Sales</th>
                          <th>Processing Fees</th>
                          <th>Paid On</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>New Commission Rates</td>
                          <td>
                            <FormGroup controlId="formperSubscriber">
                              <FormControl
                                type="number"
                                value={this.state.perSubscriber}
                                placeholder="$"
                                onChange={this.handleChange}
                                name="perSubscriber"
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="formFlaPerSale">
                              <FormControl
                                type="number"
                                value={this.state.flatPerSale}
                                placeholder="%"
                                onChange={this.handleChange}
                                name="flatPerSale"
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="formFirstSale">
                              <FormControl
                                type="number"
                                value={this.state.firstSale}
                                placeholder="%"
                                onChange={this.handleChange}
                                name="firstSale"
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="formSubsequentSale">
                              <FormControl
                                type="number"
                                value={this.state.subsequentSales}
                                placeholder="%"
                                onChange={this.handleChange}
                                name="subsequentSales"
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="formprocessingFees">
                              <FormControl
                                type="number"
                                value={this.state.processingFees}
                                placeholder="%"
                                onChange={this.handleChange}
                                name="processingFees"
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="formpaidOn">
                              <FormControl
                                componentClass="select"
                                name="paidOn"
                                onChange={this.handleChange}
                                value={this.state.paidOn}
                              >
                                <option value="sales">SALES</option>
                                <option value="revenue">REVENUE</option>
                              </FormControl>
                            </FormGroup>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end Commission Rates **/}

          {/**start additional option **/}
          <div className="panel">
            <header className="panel-heading">Additional information</header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={3} xs={12}>
                    <FormGroup controlId="formRedeemedAtCall">
                      <ControlLabel>Status</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="status"
                        onChange={this.handleChange}
                        value={this.state.status}
                      >
                        <option value="Pending">Pending</option>
                        <option value="Active">Active</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end additional option **/}

          {/**start experimental option **/}
          <div className="panel">
            <header className="panel-heading">Experimental Options</header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formUserIDtext">
                      <ControlLabel>
                        Select User (select existing user as Affiliate)
                      </ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="user_id"
                        onChange={this.handleChangeOnUser}
                        value={this.state.user_id}
                      >
                        <option value="">Select User</option>
                        {custSalesListData.map((el, key) => {
                          return (
                            <option key={key} value={el.user_id}>
                              {el.userName}
                            </option>
                          );
                        })}
                      </FormControl>
                    </FormGroup>
                  </Col>

                  <Col md={6} xs={12}>
                    <FormGroup controlId="formappend">
                      <ControlLabel>Append ?aff_id= to API calls?</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="append_aff_id"
                        onChange={this.handleChange}
                        value={this.state.append_aff_id}
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end experimental option **/}

          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                type="submit"
                id="saveButton"
                disabled={this.state.disabled}
              >
                Save
              </Button>
              <Button
                bsStyle="default"
                onClick={() => this.context.router.history.push(`/affiliateList`)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

AddAffiliate.propTypes = {
  add_affiliate: PropTypes.func.isRequired,
  getCust_SalesManagerList: PropTypes.func.isRequired,
  getAffiliateDetails: PropTypes.func.isRequired,
  update_affiliate: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    affiliateResponse: state.affiliateReducer.affiliateResponse,
    dealCities: state.dealReducer.dealCities,
    countries: state.countryCityReducers.countries,
    states: state.countryCityReducers.states,
    cityDetailsByState: state.countryCityReducers.cityDetailsByState,
    custSalesList: state.affiliateReducer.custSalesList,
    affiliateDetail: state.affiliateReducer.affiliateDetail,
    updatedAffiliate: state.affiliateReducer.updatedAffiliate,
    error: state.affiliateReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    userDetails: state.subAdminReducer.userDetails
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    getCust_SalesManagerList,
    getDealCities,
    add_affiliate,
    getAffiliateDetails,
    update_affiliate,
    get_afuser_details,
    renderAlert,
    clearAlert
  })
)(AddAffiliate);



// WEBPACK FOOTER //
// ./src/app/views/admin/marketing/affiliates/AddAffiliate.js